import React from "react";
import { useAuth } from "../../context/AuthContext";
import EndUserPortal from "../EndUser/EndUserPortal";
import CentralDashboard from "../CentralDashboard";
import CustomerAdminCommandCenter from "./CustomerAdminCommandCenter";

/**
 * DashboardRouter — renders the dashboard for each authenticated role.
 * customer_admin → tenant-scoped security Command Center
 * security_analyst → shared CentralDashboard
 * end_user → Employee Security Hub (EndUserPortal)
 * All other roles → standard CentralDashboard
 */
const DashboardRouter = () => {
  const { user, isCustomerAdmin } = useAuth();
  const isSecurityAnalyst = user?.role === "security_analyst";
  const isEndUser = user?.role === "end_user";

  if (isCustomerAdmin) {
    return <CustomerAdminCommandCenter />;
  }

  if (isSecurityAnalyst) {
    return <CentralDashboard />;
  }

  if (isEndUser) {
    return <EndUserPortal />;
  }

  return <CentralDashboard />;
};

export default DashboardRouter;
